import $ from 'jquery';

if (getCookie('cookies') != 'submited') {
  if (getCookie('cookies') != 'closed') {
    $('.js-cookies').addClass('is-active');
  }
}

$('.js-cookies-close').click(() => {
  $('.js-cookies').removeClass('is-active');
});

$('.js-cookies-agree').click(() => {
  $('.js-cookies').removeClass('is-active');
  setCookie('cookies', 'submited', 365);
  return false;
});

function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function setCookie(cname, cvalue, exdays) {
  try {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    let cookie = `${cname}=${encodeURIComponent(cvalue)};${expires};path=/`;

    // Добавляем Secure, если сайт на HTTPS
    if (window.location.protocol === 'https:') {
      cookie += ';Secure';
    }

    // Добавляем SameSite (актуально для современных браузеров)
    cookie += ';SameSite=Lax';

    document.cookie = cookie;
    console.log('Cookie установлен:', cookie); // Для отладки
  } catch (e) {
    console.error('Ошибка установки куки:', e);
  }
}
